import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import * as Yup from 'yup';
import { AddNewEmployee, EditEmployeeDetails } from "../AttendanceApis";
import Select from 'react-select';
import { formatDate, formattedDateForBE, getCurrentDate } from "../../../Common/helper/helpar";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { bouncy } from "ldrs";
bouncy.register()
const weekDays = [
    { value: 'Monday', label: 'Monday' },
    { value: 'Tuesday', label: 'Tuesday' },
    { value: 'Wednesday', label: 'Wednesday' },
    { value: 'Thursday', label: 'Thursday' },
    { value: 'Friday', label: 'Friday' },
    { value: 'Saturday', label: 'Saturday' },
    { value: 'Sunday', label: 'Sunday' },
];

export const AddEditEmployee = ({
    showModal,
    closeModal,
    zoneData,
    circleData,
    editData,
    isEditEmployee,
    setIsEditEmployee,
    fetchEmployee,
    operationsData,
    designationsData,
    identityTypesData,
    shiftsData,
    transferStationsData,
    canWriteValue
}) => {
    const [sameAsCurrentAddress, setSameAsCurrentAddress] = useState(false);
    const [loading, setLoading] = useState(false);

    const getValueByProperty = (filterValue, array, filterKey, returnKey) => {
        const filteredItems = array?.filter(item => item[filterKey] == filterValue);
        return filteredItems[0]?.[returnKey];
    };
    const stringToArray = (string) => {
        const array = string.split(",");
        return array.map(item => ({ value: item, label: item }))
    }
    
    const initialValues = {
        EmployeeName: isEditEmployee ? editData?.employeeName : "",
        OperationId: isEditEmployee ? editData?.operationId : "",
        DesignationId: isEditEmployee ? editData?.designationId : "",
        GuardianName: isEditEmployee ? editData?.guardianName ? editData?.guardianName : "" : "",
        ContactNo: isEditEmployee ? editData?.contactNo : "",
        CurrentAddress: isEditEmployee ? editData?.currentAddress : "",
        PermanentAddress: isEditEmployee ? editData?.permanentAddress || "" : "",
        DateOfJoining: isEditEmployee ? editData?.dateOfJoining ? formattedDateForBE(editData?.dateOfJoining) : "" : "",
        DateOfExit: isEditEmployee ? editData?.dateOfExit ? formattedDateForBE(editData?.dateOfExit) : "" : "",
        ZoneId: isEditEmployee ? editData?.zoneId : "",
        CircleId: isEditEmployee ? editData?.circleId : "",
        TransferStationId: isEditEmployee ? editData?.transferStationId : "",
        Gender: isEditEmployee ? editData?.gender : "",
        IdentityTypeID: isEditEmployee ? editData?.identityTypeId : "",
        IdentityNo: isEditEmployee ? editData?.identityNo : "",
        IdentityPDFUrl: isEditEmployee ? editData?.identityPDFUrl ? editData?.identityPDFUrl : null : "",
        WeekOff: isEditEmployee ? editData?.weekOff ? stringToArray(editData?.weekOff) : [] : [],
        ShiftId: isEditEmployee ? editData?.shiftId : "",
        IsActive: isEditEmployee ? editData?.isActive.toString() : "true",
    }
    const validationSchema = Yup.object({
        EmployeeName: Yup.string()
            .matches(/^[^\s]/, "Employee name cannot start with a space.")
            .matches(/^[A-Za-z\s]+$/, 'Employee name cannot contain special characters.')
            .min(3, "Employee name minimum contain 3 letters.")
            .required('Employee name is required'),
        OperationId: Yup.string()
            .required('Operation is required'),
        DesignationId: Yup.string()
            .required('Designation is required'),
        GuardianName: Yup.string()
            .matches(/^[^\s]/, "Guardian name cannot start with a space.")
            .matches(/^[A-Za-z\s]+$/, 'Guardian name cannot contain special characters.')
            .min(3, "Guardian name minimum contain 3 letters."),
        ContactNo: Yup.string()
            .typeError('Only numbers are allowed')
            .required('Contact no is required')
            .matches(/^[6-9]\d{9}$/, 'Mobile number should be a 10-digit number starting with 6, 7, 8, or 9'),
        CurrentAddress: Yup.string()
            .matches(/^[^\s]/, "Current address cannot start with a space.")
            .min(10, "Current address minimum contain 10 letters.")
            .required('Current address required'),
        PermanentAddress: Yup.string()
            .matches(/^[^\s]/, "Permanent address cannot start with a space.")
            .min(10, "Permanent address minimum contain 10 letters."),
        DateOfJoining: Yup.string()
            .required('Date of joining is required'),
        DateOfExit: Yup.date(),
        ZoneId: Yup.string()
            .required('Zone is required'),
        CircleId: Yup.string()
            .required('Circle is required'),
        TransferStationId: Yup.string()
            .required('Transfer Station is required'),
        Gender: Yup.string()
            .required('Gender is required'),
        IdentityTypeID: Yup.string()
            .required('Identity type ID is required'),
        IdentityNo: Yup.string()
            .required('Identity no is required'),
        IdentityPDFUrl: Yup.mixed()
            .required("Identity PDF file is required"),
        WeekOff: Yup.array().max(4, 'Week Off can select up to 4 days only'),
        ShiftId: Yup.string()
            .required('Shift is required'),
        IsActive: Yup.boolean(),
    });
    const handleSubmit = async (values, { resetForm }) => {
        console.log(values, "values");
        const extraPayloads = {
            OperationName: getValueByProperty(values.OperationId, operationsData, "operationId", "operationName"),
            DesignationName: getValueByProperty(values.DesignationId, designationsData, "designationId", "designationName"),
            IdentityTypeName: getValueByProperty(values.IdentityTypeID, identityTypesData, "identityTypeId", "identityTypeName"),
            ShiftName: getValueByProperty(values.ShiftId, shiftsData, "shiftId", "shiftName"),
            ZoneName: getValueByProperty(values.ZoneId, zoneData, "zoneId", "zoneName"),
            CircleName: getValueByProperty(values.CircleId, circleData, "circleId", "circleName"),
            TransferStationName: getValueByProperty(values.TransferStationId, transferStationsData, "transferStationId", "transferStationName"),
        }
        if (isEditEmployee) {
            setLoading(true)
            const editPayloadValue = {
                ...values,
                IdentityPDFUrl: editData.identityPDFUrl == values.IdentityPDFUrl ? null : values.IdentityPDFUrl,
                EmployeeId: editData.employeeId,
                IsActive: values.IsActive === 'true',
                WeekOff: values.WeekOff.map(item => item.value).toString(),
            }
            const response = await EditEmployeeDetails(editPayloadValue)
            if (response.status === 200) {
                toast.success(response?.data?.message);
                closeModal();
                setSameAsCurrentAddress(false);
                fetchEmployee();
                setIsEditEmployee(false);
                setLoading(false);
                resetForm();
            } else {
                toast.error(response.response.request.responseText);
                setLoading(false)
            }
        } else {
            setLoading(true)
            const addPayloadValue = {
                ...values,
                IsActive: values.IsActive === 'true',
                WeekOff: values.WeekOff.map(item => item.value).toString(),
            }
            const response = await AddNewEmployee(addPayloadValue)
            if (response.status === 200) {
                toast.success(response.data.message);
                closeModal();
                setSameAsCurrentAddress(false);
                fetchEmployee();
                setLoading(false);
                resetForm();
            } else {
                toast.error(response.response.data);
                setLoading(false)
            }
        }
    }
    return (
        <>
            <Modal
                size="lg"
                show={showModal}
                onHide={() => { closeModal(); setSameAsCurrentAddress(false); }}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title>
                        {isEditEmployee ? "Edit" : "Add"} Employee
                    </Modal.Title>
                    <i
                        class="fa-solid fa-xmark close-container"
                        onClick={() => { closeModal(); setSameAsCurrentAddress(false); }}
                    ></i>
                </Modal.Header>
                <Modal.Body className="small">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ handleChange, setFieldValue, values }) => (
                            <Form>
                                <Row>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="EmployeeName" className="form-label">Employee Name <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                type="text"
                                                placeholder="Enter Employee Name"
                                                className="form-control"
                                                name="EmployeeName"
                                                id="EmployeeName"
                                                maxLength="50"
                                                onInput={(e) => {
                                                    // Remove any character that is not a letter or a space
                                                    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                    setFieldValue('EmployeeName', e.target.value);
                                                }}
                                            />
                                            <ErrorMessage name="EmployeeName" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="OperationId" className="form-label">Operation <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                as="select"
                                                name="OperationId"
                                                id="OperationId"
                                                className="form-select"
                                                onChange={(e) => { handleChange(e); setFieldValue('DesignationId', "") }}
                                            >
                                                <option value="">Select Operation</option>
                                                {operationsData && operationsData
                                                    .filter((operation) => operation.isActive)
                                                    .map((operation) => (
                                                        <option key={operation.operationId} value={operation.operationId}>{operation.operationName}</option>
                                                    ))}
                                            </Field>
                                            <ErrorMessage name="OperationId" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="DesignationId" className="form-label">Designation <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                as="select"
                                                name="DesignationId"
                                                id="DesignationId"
                                                className="form-select"
                                                // onChange={(e) => { values.OperationId == "" ? setFieldValue('DesignationId', "") : setFieldValue('DesignationId', e.target.value) }}
                                            >
                                                <option value="">Select Designation</option>
                                                {designationsData && designationsData
                                                    .filter((designation) => designation.isActive && designation.operationId == values.OperationId)
                                                    .map((designation) => (
                                                        <option key={designation.designationId} value={designation.designationId}>{designation.designationName}</option>
                                                    ))}
                                            </Field>
                                            <ErrorMessage name="DesignationId" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="GuardianName" className="form-label">Guardian Name</label>
                                            <Field
                                                type="text"
                                                placeholder="Enter Guardian Name"
                                                className="form-control"
                                                name="GuardianName"
                                                id="GuardianName"
                                                maxLength="50"
                                                onInput={(e) => {
                                                    // Remove any character that is not a letter or a space
                                                    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                    setFieldValue('GuardianName', e.target.value);
                                                }}
                                            />
                                            <ErrorMessage name="GuardianName" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="ContactNo" className="form-label">Contact Number <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                type="text"
                                                placeholder="Enter Contact Number"
                                                className="form-control"
                                                maxLength={10}
                                                name="ContactNo"
                                                id="ContactNo"
                                                onInput={(e) => {
                                                    // Remove non-numeric characters and enforce max length
                                                    e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                                                    setFieldValue('ContactNo', e.target.value);
                                                }}
                                            />
                                            <ErrorMessage name="ContactNo" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="CurrentAddress" className="form-label">Current Address <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                type="text"
                                                placeholder="Enter Current Address"
                                                className="form-control"
                                                name="CurrentAddress"
                                                id="CurrentAddress"
                                                maxLength="255"
                                                onChange={(e) => {
                                                    setFieldValue("CurrentAddress", e.target.value)
                                                    sameAsCurrentAddress && setFieldValue('PermanentAddress', e.target.value)
                                                }}
                                            />
                                            <ErrorMessage name="CurrentAddress" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="PermanentAddress" className="form-label">Permanent Address</label>
                                            <Field
                                                type="text"
                                                placeholder="Enter Permanent Address"
                                                className="form-control"
                                                name="PermanentAddress"
                                                id="PermanentAddress"
                                                maxLength="255"
                                                disabled={sameAsCurrentAddress}
                                            />
                                            <label className="d-flex gap-1 align-items-center p-1" >
                                                <input
                                                    type="checkbox"
                                                    value={sameAsCurrentAddress}
                                                    onChange={(e) => {
                                                        setFieldValue('PermanentAddress', e.target.checked ? values.CurrentAddress : "");
                                                        setSameAsCurrentAddress(e.target.checked);
                                                    }}
                                                />
                                                <span>Same as Current Address</span>
                                            </label>
                                            <ErrorMessage name="PermanentAddress" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="DateOfJoining" className="form-label">Date of Joining <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                type="date"
                                                className="form-control"
                                                name="DateOfJoining"
                                                id="DateOfJoining"
                                                max={getCurrentDate()}
                                                onChange={(e) => { handleChange(e) }}
                                            />
                                            <ErrorMessage name="DateOfJoining" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="DateOfExit" className="form-label">Date of Exit</label>
                                            <Field
                                                type="date"
                                                className="form-control"
                                                name="DateOfExit"
                                                id="DateOfExit"
                                                min={values.DateOfJoining}
                                            />
                                            <ErrorMessage name="DateOfExit" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="ZoneId" className="form-label">Zone <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                as="select"
                                                name="ZoneId"
                                                id="ZoneId"
                                                className="form-select"
                                                onChange={(e) => { handleChange(e) }}
                                            >
                                                <option value="">Select Zone</option>
                                                {zoneData && zoneData
                                                    .filter((zone) => zone.isActive)
                                                    .map((zone) => (
                                                        <option key={zone.zoneId} value={zone.zoneId}>{zone.zoneName}</option>
                                                    ))}
                                            </Field>
                                            <ErrorMessage name="ZoneId" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="CircleId" className="form-label">Circle <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                as="select"
                                                name="CircleId"
                                                id="CircleId"
                                                className="form-select"
                                            >
                                                <option value="">Select Circle</option>
                                                {circleData && circleData
                                                    .filter((circle) => circle.isActive && circle.zoneId == values.ZoneId)
                                                    .map((circle) => (
                                                        <option key={circle.circleId} value={circle.circleId}>{circle.circleName}</option>
                                                    ))}
                                            </Field>
                                            <ErrorMessage name="CircleId" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="TransferStationId" className="form-label">Transfer Station <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                as="select"
                                                name="TransferStationId"
                                                id="TransferStationId"
                                                className="form-select"
                                            >
                                                <option value="">Select Transfer Station</option>
                                                {transferStationsData && transferStationsData
                                                    .filter((transferStation) => transferStation.isActive)
                                                    .map((transferStation) => (
                                                        <option key={transferStation.transferStationId} value={transferStation.transferStationId}>{transferStation.transferStationName}</option>
                                                    ))}
                                            </Field>
                                            <ErrorMessage name="TransferStationId" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="Gender" className="form-label">Gender <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                as="select"
                                                name="Gender"
                                                id="Gender"
                                                className="form-select"
                                            >
                                                <option value="">Select Gender</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </Field>
                                            <ErrorMessage name="Gender" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="IdentityTypeID" className="form-label">Identity Type ID <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                as="select"
                                                name="IdentityTypeID"
                                                id="IdentityTypeID"
                                                className="form-select"
                                            >
                                                <option value="">Select Identity Type ID</option>
                                                {identityTypesData && identityTypesData
                                                    .filter((identityType) => identityType.isActive)
                                                    .map((identityType) => (
                                                        <option key={identityType.identityTypeId} value={identityType.identityTypeId}>{identityType.identityTypeName}</option>
                                                    ))}
                                            </Field>
                                            <ErrorMessage name="IdentityTypeID" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="IdentityNo" className="form-label">Identity No <span style={{ color: '#EC1117' }}> *</span></label>
                                            <div className="position-relative">
                                                <Field
                                                    type="text"
                                                    placeholder="Enter Identity No"
                                                    className="form-control pe-5"
                                                    name="IdentityNo"
                                                    id="IdentityNo"
                                                    onInput={(e) => {
                                                        // allow only alpha-numeric characters
                                                        e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
                                                        setFieldValue('IdentityNo', e.target.value);
                                                    }}
                                                />
                                                <input
                                                    id="IdentityPDFUrl"
                                                    name="IdentityPDFUrl"
                                                    type="file"
                                                    accept="application/pdf"
                                                    style={{ display: 'none' }}
                                                    onChange={(event) => { setFieldValue('IdentityPDFUrl', event.currentTarget.files[0]); }}
                                                />
                                                <label className="position-absolute top-50 end-0 translate-middle-y m-0 pe-2 cursor-pointer" htmlFor="IdentityPDFUrl">
                                                    <FontAwesomeIcon className="h5 mb-0" icon={faUpload} />
                                                </label>
                                            </div>
                                            {isEditEmployee && (<a href={editData.identityPDFUrl}>View File</a>)}
                                            {values.IdentityPDFUrl.name ? (
                                                <div className="text-break">
                                                    <strong>Selected File:</strong> {values.IdentityPDFUrl.name}
                                                </div>
                                            ) : ""}
                                            <ErrorMessage name="IdentityPDFUrl" component="div" style={{ color: 'red', marginTop: '5px' }} />
                                            <ErrorMessage name="IdentityNo" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="form-group">
                                            <label htmlFor="WeekOff" className="form-label">Week Off Days:</label>
                                            <Select
                                                classNamePrefix="CreatableSelect"
                                                id="WeekOff"
                                                name="WeekOff"
                                                options={weekDays}
                                                isMulti
                                                value={values.WeekOff}
                                                onChange={(selected) => setFieldValue('WeekOff', selected)}
                                                placeholder="Select your week off days"
                                                menuPlacement="auto"

                                                isClearable={false}
                                            />
                                            <ErrorMessage name="WeekOff" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <div className="form-group">
                                            <label htmlFor="ShiftId" className="form-label">Shift <span style={{ color: '#EC1117' }}> *</span></label>
                                            <Field
                                                as="select"
                                                name="ShiftId"
                                                id="ShiftId"
                                                className="form-select"
                                            >
                                                <option value="">Select Shift</option>
                                                {shiftsData && shiftsData
                                                    .filter(shift => shift.isActive)
                                                    .map((shift) => (
                                                        <option key={shift.shiftId} value={shift.shiftId}>{shift.shiftName + " [" + shift.startTime + " - " + shift.endTime + "]"}</option>
                                                    ))}
                                            </Field>
                                            <ErrorMessage name="ShiftId" component="div" style={{ color: 'red' }} />
                                        </div>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <label className="form-label">
                                            Status<span style={{ color: "#EC1117" }}> *</span>
                                        </label>
                                        <div className="form-group" style={{ display: "flex", alignItems: 'center' }}>
                                            <div className="form-check d-flex">
                                                <Field
                                                    type="radio"
                                                    className="form-check-input"
                                                    name="IsActive"
                                                    id="activeRadio"
                                                    value="true"
                                                />
                                                <label className="form-check-label" htmlFor="activeRadio">
                                                    Active
                                                </label>
                                            </div>
                                            <div className="form-check ms-4 d-flex">
                                                <Field
                                                    type="radio"
                                                    className="form-check-input"
                                                    name="IsActive"
                                                    id="inactiveRadio"
                                                    value="false"
                                                />
                                                <label className="form-check-label" htmlFor="inactiveRadio">
                                                    InActive
                                                </label>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg="12" className="d-flex justify-content-center" >
                                        {canWriteValue && <button type="submit" className="deployment-button">
                                            {isEditEmployee ?
                                                loading ?
                                                    <l-bouncy
                                                        size="25"
                                                        speed="1.75"
                                                        color="white"
                                                    ></l-bouncy> : <> <i className="fa-solid fa-check done-container"></i> Update</> :
                                                loading ? <l-bouncy
                                                    size="25"
                                                    speed="1.75"
                                                    color="white"
                                                ></l-bouncy> : <> <i className="fa-solid fa-check done-container"></i> Submit </>}
                                        </button>}
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
        </>
    )
}